
export default {
    name: 'workViewer',
    title: '作品预览',
    component: () => import('../../../views/dialog/WorkViewer.vue')
}
